<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">申诉管理</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="2">
          <el-col :span="5">
            <el-form-item label="订单编号ID" prop="orderNumbers">
              <el-input v-model="queryForm.orderNumbers" placeholder="请输入订单"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申诉订单ID" prop="orderNumbers">
              <el-input v-model="queryForm.orderNumbers" placeholder="请输入订单编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申诉类型" prop="appealType">
              <el-select v-model="queryForm.appealType" clearable placeholder="请选择">
                <el-option
                    v-for="item in businessOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
              <!--<el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出
              </el-button>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-chat-dot-square" @click="handleAppeal('发起申诉')">发起申诉
      </el-button>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="id" label="ID">
          <template slot-scope="scope">
            <span>{{ getStrEndWithNumbers(scope.row.id) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appealStatusStr" label="申诉进程"/>
        <el-table-column prop="appealTypeStr" label="申诉类型"/>
        <el-table-column prop="createTime" label="申诉时间"/>
        <el-table-column prop="orderNumbers" label="订单ID"/>
        <el-table-column prop="appealImageUrl" width="160" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 120px; height: 120px"
                :src="scope.row.appealImageUrl"
                :preview-src-list="srcList(scope.row.appealImageUrl)">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="appealBeacuse" width="120" label="申诉内容"/>
        <el-table-column prop="appealSaies" width="120" label="客服回复"/>
        <el-table-column prop="remarks" label="备注"/>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="230px">
        <el-form-item label="订单编号">
          <el-input type="number" v-model="dialogForm.orderNumbers" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="申诉类型" prop="appealType">
          <el-select v-model="dialogForm.appealType" clearable placeholder="请选择">
            <el-option
                v-for="item in businessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申诉说明">
          <el-input type="textarea" v-model="dialogForm.appealBeacuse" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="截图说明">
          <el-row>
            <el-col :span="12">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogForm.appealImageUrls.length >0" :src="dialogForm.appealImageUrls[0]" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="12">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogForm.appealImageUrls.length >1" :src="dialogForm.appealImageUrls[1]" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-row>
          <div style="color: red">最多可添加2张图片，单张图片大小在3M以内选择文件</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {commitAppealMessageInfo, queryAppealList} from "../../api/b2cbusiness/b2c_admin";
import {getJwtToken, getStrEndWithNumbers} from "../../lib/utils";

export default {
  name: "BusinessAppealCenter",
  mixins: [MixinCUD],
  data() {
    return {
      myheader: {
        JWTHeaderName: ""
      },
      tableData: [],
      queryFormRefName:"queryForm",
      queryForm: {},
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        appealImageUrls: []
      },
      businessOptions:[
        {
          label:"本佣金已返买手，买手申请退款",
          value:202202110001,
        },
        {
          label:"本金已返买手，买手申请退款",
          value: 202202110002,
        },
        {
          label:"买手未好评上传错误截图要求商家返佣",
          value: 202202110003,
        },
        {
         label: "买手排错店铺，或者上传错误截图",
          value: 202202110004,
        },
        {
         label:"买手实际花费低于提交的本金",
          value:202202110005,
        },
        {

          label:"买手拍错链接",
          value: 202202110006,
        },
        {
          label:"其他错误",
          value:202202110007
        }
      ],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  computed:{
    srcList(){
      return function (url) {
        return new Array(url);
      }
    }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    this.getData();
  },
  methods: {
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.dialogForm.appealImageUrls.push(res.data);
      console.log(this.dialogForm.appealImageUrls)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarRemove(file){
      console.log(file);
    },
    getData() {
      queryAppealList(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          console.log(res.data.records);
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    addData(){
      this.dialogForm.appealImageUrl = this.dialogForm.appealImageUrls.join(",");
      commitAppealMessageInfo(this.dialogForm).then(res=>{
        if (res.success){
          this.dialogFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleAppeal(dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}


.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}
</style>
